import { render, staticRenderFns } from "./form1.vue?vue&type=template&id=1f5a9ca8&scoped=true&"
import script from "./form1.vue?vue&type=script&lang=js&"
export * from "./form1.vue?vue&type=script&lang=js&"
import style0 from "./form1.vue?vue&type=style&index=0&id=1f5a9ca8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5a9ca8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f5a9ca8')) {
      api.createRecord('1f5a9ca8', component.options)
    } else {
      api.reload('1f5a9ca8', component.options)
    }
    module.hot.accept("./form1.vue?vue&type=template&id=1f5a9ca8&scoped=true&", function () {
      api.rerender('1f5a9ca8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/terminalActivity/components/activityForm/components/form1.vue"
export default component.exports